module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 162
// module chunks = 0